import {UserRole} from './enumUtils';

class Permissions {
   constructor() {
      this.userRole = UserRole.DJ;
   }

   setUserRole(role) {
      this.userRole = role;
   }

   hasAdminPermission() {
      return this.userRole === UserRole.ADMIN || this.userRole === UserRole.VIBO_ADMIN;
   }

   hasViboAdminPermission() {
      return this.userRole === UserRole.VIBO_ADMIN;
   }
}


let permissions = new Permissions();
export default permissions;



// WEBPACK FOOTER //
// ./src/utils/permissionsUtils.js